// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"353":"contact","574":"footer","594":"about","597":"projects","859":"experience"}[chunkId] + "." + {"353":"9fb3d466","574":"d8396dc4","594":"22109504","597":"97c61c0e","859":"203f643d"}[chunkId] + ".chunk.js";
};